import type { EmbedProbeResult } from '@/shared-responder-v2-media';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function readReason(body: Record<string, unknown>): string | null {
  return typeof body.reason === 'string' ? body.reason : null;
}

/**
 * `canEmbed: false` is definitive even on a non-200 (the route uses 400 to
 * report a malformed target URL as not embeddable). Anything less certain —
 * no body, a missing field, a non-200 with no explicit `canEmbed` — resolves
 * to `true`, matching V1's `checkIframeEmbeddable` posture of letting the
 * respondent try rather than blocking on an ambiguous read.
 */
export function toEmbedProbeResultFromResponse(
  ok: boolean,
  body: unknown
): EmbedProbeResult {
  if (!isRecord(body)) {
    return { canEmbed: true, reason: null };
  }

  const reason = readReason(body);

  if (body.canEmbed === false) {
    return { canEmbed: false, reason };
  }

  if (ok) {
    return {
      canEmbed: typeof body.canEmbed === 'boolean' ? body.canEmbed : true,
      reason,
    };
  }

  return { canEmbed: true, reason: null };
}
